import React from 'react'
import Dashboard from "./components/Dashboard"
export default function(){
    return (
    <div>
        <Dashboard/>
        <h1 style={{marginLeft:'2rem', marginBottom:'2rem'}}>Chat</h1>
    </div>
    )
}